<template>


  
  <main id="maincontent" class="page-main">
    <a id="contentarea" tabindex="-1"></a>
    <div class="page messages">
      <div data-placeholder="messages"></div>
      <div data-bind="scope: 'messages'">
        <!-- ko if: cookieMessages && cookieMessages.length > 0 --><!-- /ko -->
        <!-- ko if: messages().messages && messages().messages.length > 0 --><!-- /ko -->
      </div>
    </div>

    <div class="columns">
              <!-- Sidebar -->
      <div class="sidebar sidebar-main">
        <div class="block block-collapsible-nav">
          <div class="title block-collapsible-nav-title">
            <strong>Mon compte</strong>
          </div>
          <div class="content block-collapsible-nav-content" id="block-collapsible-nav">
            <ul class="nav items">
         
              <li class="nav item"><a :href="orderHistoryUrl">Mes commandes</a></li>      
              <li class="nav item"><a :href="offerListUrl">Mes listes de souhaits</a></li>
              <li class="nav item"><span class="delimiter"></span></li>
              <li class="nav item"><a :href="editShippingAddressUrl">Carnet d’adresses</a></li>
              <li class="nav item"><a :href="editAccountUrl">Informations du compte</a></li>
            
              <li class="nav item"><span class="delimiter"></span></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="column main">
        <div class="page-title-wrapper">
          <h1 class="page-title">
            <span class="base" data-ui-id="page-title-wrapper">Mon compte</span>
          </h1>
        </div>
        <input name="form_key" type="hidden" :value="formKey">

        <!-- Informations du compte -->
        <div class="block block-dashboard-info">
          <div class="block-title"><strong>Informations du compte</strong></div>
          <div class="block-content">
            <div class="box box-information">
              <strong class="box-title">
                <span>Informations de contact</span>
              </strong>
              <div class="box-content">
                <p>
                  {{ userInfo.name }}<br>
                  {{ userInfo.email }}<br>
                </p>
              </div>
              <div class="box-actions">
                <a class="action edit" :href="editAccountUrl">
                  <button  class="button">Modifier</button>
                </a>
                <a :href="changePasswordUrl" class="action change-password">
                  <button class="button">Modifier le mot de passe</button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Carnet d’adresses -->
        <div class="block block-dashboard-addresses">
          <div class="block-title">
            <strong>Carnet d’adresses</strong><br>
            <a class="action edit" :href="manageAddressesUrl">
              <button  class="button">Gérer les adresses</button>
            </a>
          </div>
          <div class="block-content">
            <div class="box box-billing-address">
              <strong class="box-title">
                <span>Adresse de facturation par défaut</span>
              </strong>
              <div class="box-content">
                <address>
                  {{ billingAddress.name }}<br>
                  {{ billingAddress.company }}<br>
                  {{ billingAddress.street }}<br>
                  {{ billingAddress.email }}<br>
                  {{ billingAddress.city }}, {{ billingAddress.postcode }}<br>
                  {{ billingAddress.country }}<br>
                  T: {{ billingAddress.phone }}
                </address>
              </div>
              <div class="box-actions">
                <a class="action edit" :href="editBillingAddressUrl" data-ui-id="default-billing-edit-link">
                  <!--<button  class="button">Modifier l’adresse</button>-->
                </a>
              </div>
            </div>
            <div class="box box-shipping-address">
              <strong class="box-title">
                <span>Adresse de livraison par défaut</span>
              </strong>
              <div class="box-content">
                <address>
                  {{ shippingAddress.name }}<br>
                  {{ billingAddress.company }}<br>
                  {{ shippingAddress.street }}<br>
                  {{ shippingAddress.email }}<br>
                  {{ shippingAddress.city }}, {{ shippingAddress.postcode }}<br>
                  {{ shippingAddress.country }}<br>
                  T: {{ shippingAddress.phone }}
                </address>
              </div>
              <div class="box-actions">
                <a class="action edit" :href="editShippingAddressUrl" data-ui-id="default-shipping-edit-link">
                  <!--<button class="button">Modifier l’adresse</button>-->
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Commandes récentes -->
        <div class="block block-dashboard-orders">
          <div class="block-title order">
            <strong>Commandes récentes</strong> <br>
            <a class="action view" :href="orderHistoryUrl">
              <button  class="button">Voir tout</button>
            </a>
          </div>
          <div class="block-content">
            <div class="table-wrapper orders-recent">
              <table class="data table table-order-items recent" id="my-orders-table">
                <caption class="table-caption">Commandes récentes</caption>
                <thead>
                  <tr>
                    <th scope="col" class="col id">Commande #</th>
                    <th scope="col" class="col date">Date</th>
                    <th scope="col" class="col shipping">Expédié à</th>
                    <th scope="col" class="col total">Total de la commande</th>
                    <th scope="col" class="col status">Statut</th>
                    <th scope="col" class="col actions">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in recentOrders" :key="order.id">
                    <td data-th="Commande #" class="col id">{{ order.orderNumber }}</td>
                    <td data-th="Date" class="col date">{{ order.date }}</td>
                    <td data-th="Expédié à" class="col shipping">{{ order.shippedTo }}</td>
                    <td data-th="Total de la commande" class="col total">
                      <span class="price">{{ order.total }}</span>
                    </td>
                    <td data-th="Statut" class="col status">{{ order.status }}</td>
                    <td data-th="Actions" class="col actions">
                      <a :href="order.viewUrl" class="action view">
                        <span>Voir la commande</span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <button class="sticky-button" @click="goToNewOrder">
   <i class="fas fa-file-alt"></i> 
</button>
<div class="floating-icon" @click="goToCart">
  <i class="fas fa-shopping-cart"></i>
</div>

    </div>
  </main>

</template>


<script>


export default {
    name:"acountI",
  data() {
    return {
         isAuthenticated: false,
      formKey: "RGCKEYfeaOEho6XC", // Clé de formulaire
      userInfo: {
        name: "",
        email: "",
      },
      billingAddress: {
        name: "",
        company: "",
        street: "",
        email: "",
        city: "",
        postcode: "",
        country: "",
        phone: "",
      },
      shippingAddress: {
        name: "",
        company: "",
        street: "",
        email: "",
        city: "",
        postcode: "",
        country: "",
        phone: "",
      },
      recentOrders: [
        {
          orderNumber: "",
          date: "",
          shippedTo: "",
          total: "",
          status: "",
          viewUrl: "",
        },
      ],
      
      editAccountUrl: "http://localhost:8081/edit-account",
      changePasswordUrl: "http://localhost:8081/change-mot-passe",
      manageAddressesUrl: "http://localhost:8081/carnetAdresses",
      editBillingAddressUrl: "http://localhost:8081/carnetAdresses",
      editShippingAddressUrl: "http://localhost:8081/carnetAdresses",
      orderHistoryUrl: "http://localhost:8081/orderStatus",
      offerListUrl: "http://localhost:8081/wishlist",

      
    }
  },
    created() {
      this.checkUserStatus(); //Appelle cette méthode au démarrage
          this.fetchRecentOrders();
  },
mounted() {
  // Écoute l'événement personnalisé
  window.addEventListener("addressUpdated", this.syncAddress);
},
beforeUnmount() {
  // Nettoyage propre
  window.removeEventListener("addressUpdated", this.syncAddress);
},

    methods: {
  checkUserStatus() {
    const user = sessionStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      console.log("Données utilisateur récupérées : ", userData);
      this.userInfo = {
        name: userData.civilite + " " + userData.prenom + " " + userData.nom,
        email: userData.email
      };

      this.billingAddress = {
        name: userData.civilite + " " + userData.prenom + " " + userData.nom,
        company: userData.societe || "",
        street: userData.adresse || "",
        email: userData.email,
        city: userData.ville || "",
        postcode: userData.codePostal || "",
        country: userData.pays || "",
        phone: userData.telephone || ""
      };

      this.shippingAddress = { ...this.billingAddress };
      this.isAuthenticated = true;
    } else {
      this.$router.push('/connexion');
    }
  },

  
  async fetchRecentOrders() {
    try {
      const token = sessionStorage.getItem("token");
        const storedUser = JSON.parse(sessionStorage.getItem("user"));

      if (!storedUser || !storedUser._id) {
        console.warn("Utilisateur non connecté");
        return;
      }

      const response = await fetch(`http://localhost:2028/api/orders/user/${storedUser._id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (response.ok) {
      this.recentOrders = data
        .slice(0, 1) // Garde seulement la première commande (déjà triée)
        .map(order => ({
          orderNumber: order.orderNumber,
          date: new Date(order.createdAt).toLocaleString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }).replace(',', ' à'), // Résultat : "13/04/2025 à 15:45"
          shippedTo: order.selectedAddress?.firstName + " " + order.selectedAddress?.lastName,
          total: Number(order.total).toFixed(2) + " MAD",
          status: order.status || "En cours",
          viewUrl: `/orderDetail/${order._id}`
        }));

      } else {
        console.error("Erreur récupération commandes :", data.message);
      }
    } catch (error) {
      console.error("Erreur lors de l'appel API :", error);
    }
  },
        /*logout() {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            this.isAuthenticated = false;
            this.userInfo = { name: "", email: "" };
            this.$router.push('/connexion');
        }
    },
watch: {
    '$route'() {  // Supprimer `to` et `from` si tu ne les utilises pas
        this.checkUserStatus();  
    },
    isAuthenticated(newVal) {
        if (newVal) {
            this.checkUserStatus();
        }
    }*/

      goToNewOrder() {
    this.$router.push('/shop');
      },
    goToCart() {
    this.$router.push('/panier');
      },
    syncAddress() {
      // Recharge les infos à partir du sessionStorage
     console.log("Adresse mise à jour détectée !");
    this.checkUserStatus();
  }
}


}

</script>

<style scoped>
/* ======= STYLE CLAIR (inchangé) ======= */
.page-main {
  padding: 40px 20px;
  max-width: 1280px;
  margin: auto;
  background-color: #f9f9f9;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}

.columns {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.column.main {
  flex: 1 1 72%;
  background-color: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.sidebar.sidebar-main {
  flex: 1 1 25%;
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.page-title-wrapper {
  margin-bottom: 25px;
}

.page-title {
  font-size: 28px;
  color: #1f1f1f;
  font-weight: 600;
}

/* Navigation */
.block-collapsible-nav-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #2b2b2b;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.nav.items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav.item {
  margin-bottom: 15px;
}

.nav.item a {
  color: #444;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.nav.item a:hover {
  color: #00998B;
}

/* Delimiters */
.delimiter {
  height: 1px;
  background-color: #e0e0e0;
  margin: 15px 0;
}

/* Blocks */
.block {
  margin-bottom: 30px;
}

.block-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #1e1e1e;
}

.box {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #fafafa;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
}

.box-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.box-content p,
.box-content address {
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.box-actions {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.button {
  background-color: #00998B;
  color: white;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.button:hover {
  background-color: #007e72;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

/* Table Styles */
.table-wrapper {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

table th,
table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}

table th {
  background-color: #f0f0f0;
  font-weight: 600;
}

table td .price {
  font-weight: 600;
  color: #00998B;
}

.action.view span {
  color: #00998B;
  font-weight: 500;
}

.action.view span:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 1024px) {
  .columns { flex-direction: column; gap: 20px; }
  .page-main { padding: 30px 15px; }
  .sidebar.sidebar-main, .column.main {
    max-width: 100%;
    flex: 1 1 100%;
    padding: 20px;
  }
}

/* Sticky buttons */
.sticky-button, .floating-icon {
  position: fixed;
  left: 20px;
  background-color: #00998B;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  z-index: 999;
  transition: background-color 0.3s;
}

.sticky-button {
  bottom: 20px;
  padding: 12px 16px;
  border-radius: 50px;
}

.floating-icon {
  bottom: 80px;
  font-size: 22px;
  padding: 12px;
}

.sticky-button:hover,
.floating-icon:hover {
  background-color: #007e72;
}

/* ===== MODE SOMBRE ===== */
@media (prefers-color-scheme: dark) {
  .page-main {
    background-color: #0f141b;
    color: #e6edf1;
  }

  .column.main,
  .sidebar.sidebar-main {
    background-color: #1a1f29;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
    border: 1px solid #2b3645;
  }

  .page-title,
  .block-title,
  .block-collapsible-nav-title,
  .box-title {
    color: #aef7f0;
  }

  .nav.item a {
    color: #e6edf1;
  }

  .nav.item a:hover {
    color: #00bfa5;
  }

  .box {
    background-color: #18222e;
    border-color: #2e3a49;
  }

  table {
    color: #e6edf1;
    background-color: #1f2733;
  }

  table th {
    background-color: #2a3442;
    color: #aef7f0;
  }

  table td {
    border-color: #2e3a49;
  }

  table td .price {
    color: #00bfa5;
  }

  .button {
    background-color: #00bfa5;
  }

  .button:hover {
    background-color: #00d6ba;
  }

  .sticky-button,
  .floating-icon {
    background-color: #00bfa5;
  }

  .sticky-button:hover,
  .floating-icon:hover {
    background-color: #00e6c1;
  }
}
</style>
